import { useEffect, useState } from "react";
import Permissions from "../../components/Permissions/Permissions";
import { Button } from "@mui/material";

const NonIphoneLightShow = (props) => {
  const { onShowMainContent, eventId, needsPermission, appIcon } = props;
  const [permissionsGranted, setPermissionsGranted] = useState(false);
  const [notificationPermission, setNotificationPermission] =
    useState("prompt");
  const handlePermissionsGranted = () => {
    setPermissionsGranted(true);
    onShowMainContent();
  };

  useEffect(() => {
    const checkPermissions = async () => {
      // Check Notification Permission
      if ("Notification" in window) {
        setNotificationPermission(Notification.permission);
      }
    };

    checkPermissions();
  }, []);

  return (
    <>
      {!permissionsGranted && (
        <Permissions
          onPermissionsGranted={handlePermissionsGranted}
          eventId={eventId}
          handleContinueWithoutNotifications={handlePermissionsGranted}
          needsPermission={needsPermission}
          appIcon={appIcon}
        />
      )}
    </>
  );
};
export default NonIphoneLightShow;
